// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3Y8xY","label":"CategoryService_label__3xTSM","location":"CategoryService_location__ee_XL"};